<template>
  <td>
    <img v-if="icon()" :src="icon()" alt="" height="50" width="50" />
  </td>
</template>

<script>
import {  getVehiclesSideView } from "@/utils/icons";
// import redBus from "@/assets/icons/vehicles/bus-3d/red.svg";
export default {
  props: {
    dataItem: Object,
  },
  methods: {
    icon() {
      try {
        const vehicleType = this.$store.getters["vehicle/getVehicleTypes"].find(
          (vcl) => vcl.id === this.dataItem.vehicleType
        );
        let vehicleName = vehicleType ? vehicleType.type : this.dataItem.vehicleType ?  this.dataItem.vehicleType : '';
        return getVehiclesSideView(vehicleName);
      } catch (error) {
        console.log('Something went wrong:  ', error);
      }

    },
  },
};
</script>

<style scoped>
</style>